import { RESET_NOTIFICATION, SET_NOTIFICATION } from "../types"

export const setNotification = (data) => ({
	type: SET_NOTIFICATION,
	payload: data,
})

export const resetNotification = () => ({
	type: RESET_NOTIFICATION,
})
